export { default as ResponsiveImage } from "./Responsive";
export { default as StaticImage } from "./Static";
export { default as ThumbnailCircle } from "./ThumbnailCircle";
export { default as StyledImageSeo } from "./Seo.styles";



// WEBPACK FOOTER //
// ./src/components/Image/index.js